module.exports = __webpack_public_path__ + "img/LF_8-6.d8ca3134.svg";